"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var system_1 = require("@mui/system");
var TableRow_1 = __importDefault(require("atomicComponents/atoms/Table/TableRow"));
var TeamTableRow = (0, system_1.styled)(TableRow_1.default, { shouldForwardProp: function (prop) { return prop !== 'isActive'; } })(function (_a) {
    var isActive = _a.isActive, theme = _a.theme;
    return ({
        borderRadius: 10,
        ':hover': {
            backgroundColor: theme.palette.primary.outlined.hover.backgroundColor,
            '.MuiIconButton-root': {
                visibility: 'visible',
            },
        },
        backgroundColor: isActive && theme.palette.primary.outlined.hover.backgroundColor,
    });
});
exports.default = TeamTableRow;
